export const formatRounding = (n) => {
  const h = +"1".padEnd(2 + 1, "0"); // 10 or 100 or 1000 or etc
  return parseFloat(Math.round(n * h) / h);
};

export const formatCeil = (n, x) => {
  const y = 1;
  const z = x + y;
  const h = +"1".padEnd(z, "0"); // 10 or 100 or 1000 or etc
  return parseFloat(Math.ceil(n * h) / h);
};

export const formatFloor = (n, x) => {
  const y = 1;
  const z = x + y;
  const h = +"1".padEnd(z, "0"); // 10 or 100 or 1000 or etc
  return parseFloat(Math.floor(n * h) / h);
};

function decimalMultiplier(num) {
  if (typeof num !== "number" || isNaN(num)) return 1;

  const str = num.toString();

  if (!str.includes(".")) return 1;

  const decimalLength = str.split(".")[1].length;

  return 10 ** decimalLength;
}

export const formatRoundingNumber = (n) => {
    const totalLength = decimalMultiplier(n);
    return Math.round(Number(n) * totalLength) / totalLength
}